import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  Stack,
} from "@mui/material";
import CustomTextField from "../../shared-components/form-controls/customTextField";

const SignupRefPopup = ({ open, onClose, onGetRefName }) => {
  const [phase, setPhase] = useState("initial");
  const { t } = useTranslation();

  const formConfig = {
    emailParamValueId: {
      name: "repID",
      label: t("SignupCommonField.Common.EnterREPSiteNameOrEmail"),
      type: "text",
      maxLength: 100,
      required: true,
    },
  };

  const methods = useForm({
    mode: "all",
    defaultValues: {
      repID: "",
    },
  });

  const { handleSubmit, setFocus } = methods;

  const handleInitialOkClick = () => {
    setPhase("form");
  };

  useEffect(() => {
    if (phase === "form") {
      setFocus("repID");
    }
  }, [phase]);

  const onSubmit = (data) => {
    if (data.repID.trim() !== "") {
      onGetRefName(data);
    }
  };

  return (
    <Dialog
      className="login-popup"
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          onClose();
        }
      }}
      fullWidth
    >
      <Stack
        sx={(theme) => ({
          background: theme.palette.common.black,
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
        })}
      >
        <DialogTitle>
          <Typography variant="h6" component="div" color="primary">
            {t("SignupCommonField.Common.ReferralDetailsPopupTitle")}
          </Typography>
        </DialogTitle>
      </Stack>
      <DialogContent
        sx={{
          background: "var(--background-card)!important",
          border: 0,
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
        dividers
      >
        {phase === "initial" && (
          <>
            <Typography sx={{ mb: 2 }}>
              {t("SignupCommonField.Common.ReferralDetailsPopupText1")}
            </Typography>
            <Box width="100%" pb={1}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleInitialOkClick}
              >
                {t("SignupCommonField.Common.ReferralDetailsPopupButtonText")}
              </Button>
            </Box>
          </>
        )}
        {phase === "form" && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <CustomTextField
              methods={methods}
              properties={formConfig.emailParamValueId}
            />
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button
                variant="contained"
                sx={{ px: 3, width: { xs: "100%", sm: "auto" } }}
                color="primary"
                type="submit"
              >
                {t("Common.Ok")}
              </Button>
            </Box>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SignupRefPopup;
